import React from 'react';
import PropTypes from 'prop-types';
import { Button, H4, Flex, P } from '@decisiv/ui-components';
import ArrowRight from '@decisiv/iconix/lib/components/ArrowRight';
import checkmark from '../../../../../assets/images/checkmark.png';
import { Checkmark, GreyP, Padding } from './styledComponents';
import { REQUEST_EMAIL } from '../constants';
import { interpolate } from '../utils';

function WelcomeScreen({ requestType, onContinue, translations, realUser }) {
  const channel =
    requestType === REQUEST_EMAIL
      ? translations.channelEmail
      : translations.channelMobile;
  const noRequestNeeded = requestType === 'ok';

  const accountAssociatedMarkup = { __html: translations.accountAssociatedHtml };

  return (
    <Padding>
      <Checkmark src={checkmark} />
      {noRequestNeeded && (
        <H4>
          {/* eslint-disable-next-line react/no-danger */}
          <span dangerouslySetInnerHTML={accountAssociatedMarkup} />
        </H4>
      )}

      {!noRequestNeeded && (
        <>
          <GreyP>{interpolate(translations.channelAdded, { channel })}</GreyP>
          <GreyP>{interpolate(translations.channelUpdates, { channel })}</GreyP>
        </>
      )}
      <Flex style={{ marginTop: 10 }}>
        {onContinue && (
          <Button
            icon={ArrowRight}
            text={translations.goToCase}
            iconPosition="right"
            onClick={() => onContinue()}
          />
        )}
        {!onContinue && (
          <P shade={1} paddingTop={2}>
            {translations.noCommunications}
          </P>
        )}
      </Flex>
      {realUser && (
        <Flex marginTop={4}>
          <a href="/mobilecomm/users/edit_current">
            {translations.reviewNotificationPreferences}
          </a>
        </Flex>
      )}
    </Padding>
  );
}

WelcomeScreen.propTypes = {
  requestType: PropTypes.string,
  onContinue: PropTypes.func,
  translations: PropTypes.objectOf(PropTypes.string),
  realUser: PropTypes.bool,
};

WelcomeScreen.defaultProps = {
  requestType: '',
  onContinue: null,
  translations: {},
  realUser: false,
};

export default WelcomeScreen;
